<template>
  <div>
    <p class="boss-text">
      [{{ content.parentName }}]
    </p>
    <div class="padding-left-1">
      <span
        :id="targetId"
        data-test="value"
        class="pega-break pega-pre-wrap"
        v-text=" nameValue || '未登録' "
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    targetId: {
      type: String,
      default: ''
    },
    content: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    nameValue () {
      return this.content.nameList.length ? this.content.nameList.join('\n') : null
    }
  }
}
</script>
